var map = {
	"./1 foto en portraits.jpg": 3965,
	"./157dda11-06ae-4503-872c-04908a65678c.jpg": 7856,
	"./2 foto portraits.jpg": 6063,
	"./3 foto portraits.jpg": 1836,
	"./4 foto portraits.jpg": 2829,
	"./4e8e54ed-cc27-4cf2-809e-1d07532206b9.jpg": 1202,
	"./5 foto portraits.jpg": 2986,
	"./63c3cffb-6a9f-4f63-a3f5-6ce55a67dc1c.jpg": 3924,
	"./FF4C1751-DAD3-473E-A857-70E749F7446B.jpg": 7243,
	"./IMG_1238.jpg": 6527,
	"./IMG_4335.jpg": 2628,
	"./IMG_9122.jpg": 7449,
	"./IMG_9255.jpg": 4580,
	"./IMG_9256.jpg": 803,
	"./IMG_9257.jpg": 2390,
	"./IMG_9627.jpg": 783,
	"./IMG_9833.JPG": 8819,
	"./Laurea in canto rinascimentale e barocco.jpg": 470,
	"./Opcional 1.jpg": 2651,
	"./Opcional 2.jpg": 9852,
	"./Opcional 3.jpg": 7641,
	"./Opcional 4.jpg": 8154,
	"./a858fdec-416e-40fc-b08a-c8759a8c7e4a.jpg": 5222,
	"./f805f1d5-2c53-4361-9435-bad570b1a598.jpg": 1625,
	"./presentacion.mp4": 5411
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3751;